/*
 * View for the search pane of the Topics Area
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/contentsSplit/contents/contentsSearch/template/contentsSearchTemplate.html",
  "modules/typeahead/typeaheadModel",
], function (Marionette, Messenger, ContentSearchTemplate, TypeaheadModel) {
  var ContentsSearchView = {};

  ContentsSearchView.contentsSearchView = Marionette.ItemView.extend({
    SEARCH_BY_NAME: 1,
    SEARCH_BY_URL_STRING: 2,
    SEARCH_BY_MISSING: 3,
    SEARCH_BY_MODIFIED: 4,
    SEARCH_BY_IGNORED: 5,
    SEARCH_BY_NEW: 6,
    template: ContentSearchTemplate,
    events: {
      "change #searchModes": function () {
        var optionSelected = parseInt(this.$el.find("#searchModes option:selected").val(), 10);
        this.model.set("mode", optionSelected);
      },
      "change #contentLocale": function () {
        var selectedLocale = parseInt(this.$el.find("#contentLocale option:selected").val(), 10);
        this.model.selectedLocale = selectedLocale;
      },
    },
    modelEvents: {
      change: "render",
    },
    onRender: function () {
      this.$el.i18n();

      //set up typeahead when applicable
      if (
        this.model.get("mode") === this.SEARCH_BY_NAME ||
        this.model.get("mode") === this.SEARCH_BY_URL_STRING
      ) {
        //set up source function to get the typeahead data
        var _this = this;
        var sourceFunction = function (query, process) {
          var results;
          if (_this.model.get("mode") === _this.SEARCH_BY_NAME) {
            results = Messenger.reqres.request("contents:typeahead", query);
          } else {
            results = Messenger.reqres.request("content:urls:typeahead", query);
          }
          results.once(
            "sync",
            function () {
              process(results.getResultsArray());
            },
            this,
          );
        };
        //this handler prevents typeahead from using the "enter" keypress to search by the typeahead suggestion
        this.$el.find("input").on("keyup", function (e) {
          if (e.keyCode == 13) {
            e.stopImmediatePropagation(); //stop typeahead from getting this event
            //now we need to trigger the click:search event, because the propagation was stopped
            _this.trigger("click:search", { view: _this, model: _this.model });
            //and close the typeahead as well
            _this.$el.find(".typeahead").hide();
          }
        });

        this.$el.find("input").typeahead({
          source: sourceFunction,
          updater: function (item) {
            //set the value of the textbox
            _this.$el.find("input").val(item);
            _this.trigger("click:search", { view: _this, model: _this.model }); //trigger event on view, passing the standard args hash
            return item;
          },
        });
      }
    },
    searchMode: function () {
      return this.model.get("mode");
    },
    triggers: {
      "submit form": "click:search",
    },
  });

  return ContentsSearchView;
});
